module.exports = __webpack_public_path__ + "static/media/product-design.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/product-design.svg
// module id = 514
// module chunks = 0